// extracted by mini-css-extract-plugin
module.exports = {"header":"Folder_header__1dpuf","content":"Folder_content__1LMNb","gallery":"Folder_gallery__3BzyZ"};